import React from 'react';
import { Header } from '../types';
import { HEADER_COLUMNS } from '../constants/columns';
import { formatDate } from '../utils/dateFormatter';

interface HeaderTableProps {
  headers: Header[];
  onHeaderClick: (header: Header) => void;
  selectedHeader?: Header;
  isDarkTheme?: boolean;
}

const HeaderTable: React.FC<HeaderTableProps> = ({ headers, onHeaderClick, selectedHeader, isDarkTheme }) => {
  const getHeaderValue = (header: Header, column: string): string => {
    const fieldMap: Record<string, keyof Header> = {
      'Request Number': 'requestNumber',
      'From Site': 'fromSite',
      'To Site': 'toSite',
      'Type': 'type',
      'Status': 'status',
      'Creation Date': 'creationDate',
      'Tracking Number': 'trackingNumber',
      'Tracking Status': 'trackingStatus',
      'Expected Delivery Date': 'expectedDeliveryDate',
      'Delivered Date': 'deliveredDate',
      'Region': 'region'
    };
    const value = header[fieldMap[column]] || '';
    const dateColumns = ['Creation Date', 'Expected Delivery Date', 'Delivered Date'];
    
    if (dateColumns.includes(column) && value) {
      return formatDate(String(value));
    }
    
    return String(value);
  };

  return (
    <div style={{ marginBottom: '10px' }}>
      <div style={{ maxHeight: '350px', overflowY: 'auto', border: `1px solid ${isDarkTheme ? '#555' : '#ccc'}` }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ backgroundColor: isDarkTheme ? '#444' : '#f5f5f5' }}>
            {HEADER_COLUMNS.map((column) => (
              <th key={column} style={{ padding: '8px', border: `1px solid ${isDarkTheme ? '#555' : '#ccc'}`, textAlign: 'left', color: isDarkTheme ? '#fff' : '#000', fontSize: '13px', position: 'sticky', top: '0', backgroundColor: isDarkTheme ? '#444' : '#f5f5f5', zIndex: 10 }}>
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {headers.length === 0 ? (
            <tr style={{ backgroundColor: isDarkTheme ? '#2a2a2a' : 'white', color: isDarkTheme ? '#fff' : '#000' }}>
              {HEADER_COLUMNS.map((column) => (
                <td key={column} style={{ padding: '8px', border: `1px solid ${isDarkTheme ? '#555' : '#ccc'}`, color: isDarkTheme ? '#fff' : '#000', fontSize: '12px' }}>
                  
                </td>
              ))}
            </tr>
          ) : (
            headers.map((header, index) => (
              <tr
                key={index}
                onClick={() => onHeaderClick(header)}
                style={{
                  cursor: 'pointer',
                  backgroundColor: selectedHeader?.requestNumber === header.requestNumber 
                    ? (isDarkTheme ? '#0d47a1' : '#e3f2fd') 
                    : (isDarkTheme ? '#2a2a2a' : 'white'),
                  color: isDarkTheme ? '#fff' : '#000'
                }}
              >
                {HEADER_COLUMNS.map((column) => (
                  <td key={column} style={{ padding: '8px', border: `1px solid ${isDarkTheme ? '#555' : '#ccc'}`, color: isDarkTheme ? '#fff' : '#000', fontSize: '12px' }}>
                    {getHeaderValue(header, column)}
                  </td>
                ))}
              </tr>
            ))
          )}

        </tbody>
        </table>
      </div>
    </div>
  );
};

export default HeaderTable;